export class AxiosResultDeleteStatus {
  status!: number;
  entity!: any;
  hasErrors!: boolean;
  errorMessage: string = "";
}
